import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2 } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from '../ui/alert-dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ClearPracticeOrders = ({ authHeaders, count, onDone }) => {
  const [busy, setBusy] = useState(false);
  const clear = async () => {
    setBusy(true);
    try {
      const r = await axios.delete(`${API}/admin/orders/practice`, authHeaders);
      toast.success(`${r.data.deleted} practice order${r.data.deleted === 1 ? '' : 's'} deleted`);
      onDone();
    } catch { toast.error('Could not delete practice orders'); } finally { setBusy(false); }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button disabled={!count || busy} data-testid="clear-practice-orders-btn"
          className="flex items-center gap-2 text-sm text-red-700 disabled:text-[#1E1622]/30 hover:text-red-900 transition-colors duration-200">
          <Trash2 size={16} /> Clear practice orders{count ? ` (${count})` : ''}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="clear-practice-orders-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete all practice orders?</AlertDialogTitle>
          <AlertDialogDescription>
            This permanently removes every order tagged Practice, including their download links in My Orders. Real customer orders are not touched.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="clear-practice-orders-cancel">Keep them</AlertDialogCancel>
          <AlertDialogAction onClick={clear} data-testid="clear-practice-orders-confirm" className="bg-red-700 hover:bg-red-800">Delete practice orders</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
